import { render } from "./KioskLaunch.vue?vue&type=template&id=1a352488"
import script from "./KioskLaunch.vue?vue&type=script&lang=js"
export * from "./KioskLaunch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__